import ErrorForm from 'app/commons/components/ErrorForm';
import React from 'react';

interface SelectFormProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  required?: boolean;
  show?: boolean;
  showOptionBlank?: boolean;
  options: React.ReactNode;
  handleChange?: (value: string, name?: string) => void;
}

const SelectForm: React.FC<SelectFormProps> = ({
  label,
  error,
  required = false,
  show = true,
  showOptionBlank = true,
  options,
  handleChange,
  ...props
}) => {
  if (!show) return null;

  const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value, name } = e.target;
    handleChange?.(value, name);
    props.onChange?.(e);
  };

  return (
    <div className="form-select">
      {label && <label className={required ? 'required' : ''}>{label}</label>}
      <select
        {...props}
        value={props.value || ''}
        className={`form-control mt-2 ${props.className || ''}`}
        onChange={onSelectChange}
      >
        {showOptionBlank && <option value=""></option>}
        {options}
      </select>
      <ErrorForm error={error} />
    </div>
  );
};

export default SelectForm;
